/** Class representing a WS connection error
 *  @extends Error
 */
export default class WSConnectionError extends Error {
    /**
     * Create a WSConnectionError
     * @param {object} pusherError
     */
    constructor(pusherError) {
        super(pusherError.error.data.message);
        this.errorCode = pusherError.error.data.code;
        this.message = pusherError.error.data.message;
    }
}
